import { Row } from '@tanstack/react-table';
import { EleveGroup } from 'types/eleveGroups';

export function sortGroups(
  rowA: Row<any>,
  rowB: Row<any>,
  columnId: string,
  eleveGroups: EleveGroup[],
) {
  const val1 = rowA.getValue(columnId) as string[];
  const val2 = rowB.getValue(columnId) as string[];

  // Empty values at the end
  const isEmpty1 = !val1?.length;
  const isEmpty2 = !val2?.length;
  if (isEmpty1 && isEmpty2) return 0;
  if (isEmpty1) return 1;
  if (isEmpty2) return -1;

  // Then sort by name
  const group1 = eleveGroups.find(c => c.id === val1[0])?.name;
  const group2 = eleveGroups.find(c => c.id === val2[0])?.name;
  if (!group1 && !group2) return 0;
  if (!group1) return 1;
  if (!group2) return -1;

  return group1.localeCompare(group2);
}
